import React from "react"

const DashboardView = () => {
    return (
        <div className="full-width">
            Logged In
        </div>
    )
}

export default DashboardView